import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Slider from 'react-slick';
import './../../../node_modules/slick-carousel/slick/slick.css';
import './../../../node_modules/slick-carousel/slick/slick-theme.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getTheme, getThemeName } from 'utils/themeUtils';
import { history } from 'configureStore';
import Slide from './Slide';

const StyledSlider = styled(Slider)`
  height: 100%;
  max-width: ${props => props.theme.styledSlider.maxWidth};

  .slick-slide h3 {
    background: #eee;
    margin: 0 5px;
    padding: 1em;
  }

  .slick-slide {
    height: 100%;
    overflow: hidden;

    & div {
      height: 100%;
      padding: ${props => (props.overlayButtons ? '0' : '0px 2px')};
      cursor: pointer;
    }

    & img {
      height: ${props => (props.overlayButtons ? 'auto' : '100%')};
      width: ${props => (props.overlayButtons ? '100%' : 'auto')};

      /* Internet Explorer 11 Specific Rule */
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        height: ${props => (props.overlayButtons ? 'auto' : '6em')};
      }
    }
  }

  .slick-arrow {
    max-height: 6em;
    z-index: 1;

    &:focus {
      box-shadow: ${props => props.theme.forms.input.focusOutline};
    }
  }

  .slick-arrow::before {
    content: '';
  }

  .slick-arrow .fa-caret-left,
  .slick-arrow .fa-caret-right {
    color: #fff;
    font-size: 2em;
  }

  .slick-list {
    height: 100%;
    margin: ${props => (props.overlayButtons ? '0' : '0 0.5em')};
    overflow: hidden;
  }

  .slick-track {
    height: 100%;
  }

  .slick-prev {
    left: ${props => (props.overlayButtons ? '0' : '-25px')};
  }

  .slick-next {
    right: ${props => (props.overlayButtons ? '0' : '-25px')};
  }
`;

class ArrowPrev extends Component {
  handleClick = () => {
    const { onClick, resetAutoplay } = this.props;

    resetAutoplay();
    onClick();
  };

  render() {
    const { className, style, theme } = this.props;

    return (
      <button
        className={className}
        onClick={this.handleClick}
        style={{
          ...style,
          height: '100%',
          fontSize: '1em',
          width: '2em',
          backgroundColor: theme.buttons.primary.backgroundColor
        }}
        aria-label="See previous images"
      >
        <FontAwesomeIcon
          icon="caret-left"
          aria-label="Left-facing caret arrow"
        />
      </button>
    );
  }
}

class ArrowNext extends Component {
  handleClick = () => {
    const { onClick, resetAutoplay } = this.props;

    resetAutoplay();
    onClick();
  };

  render() {
    const { className, style, theme } = this.props;
    return (
      <button
        className={className}
        onClick={this.handleClick}
        style={{
          ...style,
          height: '100%',
          fontSize: '1em',
          width: '2em',
          backgroundColor: theme.buttons.primary.backgroundColor
        }}
        aria-label="See next images"
      >
        <FontAwesomeIcon
          icon="caret-right"
          aria-label="Right-facing caret arrow"
        />
      </button>
    );
  }
}

export class ImageSlider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      autoplay: true,
      timeoutId: null
    };

    this.sliderRef = React.createRef();
  }

  handleClick = e => {
    const { to, navigateBack } = this.props;

    navigateBack(to);
  };

  handleSlideClick = imageIndex => {
    const { showLightbox } = this.props;

    if (showLightbox) {
      showLightbox(imageIndex);
    }
  };

  resetAutoplay = () => {
    const { settings } = this.props;
    const { autoplay } = settings;

    let timeoutId = this.state.timeoutId;
    if (timeoutId) {
      clearTimeout(this.state.timeoutId);
      timeoutId = null;
    }

    if (autoplay && this.sliderRef.current) {
      timeoutId = setTimeout(() => {
        this.setState({ autoplay: true });
        this.sliderRef.current.slickPlay();
      }, 10000);
    }

    this.setState({ autoplay: false, timeoutId });
  };

  render() {
    const { property, images, settings, overlayButtons } = this.props;

    const themeName = getThemeName(history.location);
    const theme = getTheme(themeName);

    const defaultSettings = {
      infinite: true,
      speed: 500,
      slidesToShow: property === 'wetumpka' ? 5 : 4,
      slidesToScroll: 1,
      variableWidth: true,
      nextArrow: <ArrowNext theme={theme} resetAutoplay={this.resetAutoplay} />,
      prevArrow: <ArrowPrev theme={theme} resetAutoplay={this.resetAutoplay} />
    };

    // Here we combine settings passed in props with the default settings.
    // If autoplay is true, then we use the autoplay flag from the component
    // state, which toggles off when the user clicks Next/Prev.
    const { autoplay, speed, ...propsSettings } = settings;
    const combinedSettings = Object.assign({}, defaultSettings, {
      ...propsSettings,
      autoplay: autoplay ? this.state.autoplay : false,
      speed: autoplay && !this.state.autoplay ? 500 : speed
    });

    return (
      <StyledSlider
        {...combinedSettings}
        overlayButtons={overlayButtons}
        innerRef={this.sliderRef}
      >
        {images &&
          images.map((imageSrc, i) => {
            return (
              <Slide
                key={i}
                onClick={this.handleSlideClick}
                index={i}
                property={property}
                imageSrc={imageSrc}
              />
            );
          })}
      </StyledSlider>
    );
  }
}

ImageSlider.propTypes = {
  className: PropTypes.string,
  property: PropTypes.string,
  images: PropTypes.array,
  settings: PropTypes.object,
  overlayButtons: PropTypes.bool,
  showLightbox: PropTypes.func
};

export default ImageSlider;
